class Video {
  constructor(el) {
    this.el = el;
    this.elButton = this.el.querySelector('[data-video-play-button]');
    this.elIframe = this.el.querySelector('iframe');
    this.elWpVideo = this.el.querySelector('.wp-video video');
    this.elImage = this.el.querySelector('[data-video-image]');
    this.initVideo();
  }

  initVideo() {
    this.elButton.addEventListener('click', this.playVideo.bind(this));
  }

  playVideo() {
    if (this.elIframe) {
      this.elIframe.src += '&autoplay=1';
    }
    if (this.elWpVideo) {
      const player = window.mejs.players['mep_0'];
      if (player) player.play();
    }
    this.elImage.classList.add('hidden');
  }
}

export default Video;
